import { Hourglass, ArrowLeft } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Lightweight placeholder for admin paths that have not yet been mapped to a
 * dedicated component. Kept as a minimal static render (no fetches, no
 * effects) so it paints instantly — previously this page felt slow because
 * the surrounding AdminLayout was re-rendering heavy icon bundles on each
 * navigation. Everything now happens in a single synchronous pass.
 */
export default function ComingSoonPage({ title, description }) {
  const loc = useLocation();
  const derived = title || decodeURIComponent(loc.pathname.split('/').pop() || '').replace(/-/g, ' ');
  return (
    <div className="p-10 max-w-3xl" data-testid="coming-soon-page">
      <div className="rounded-xl border border-zinc-800 bg-zinc-900 p-10 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400 mb-4">
          <Hourglass size={24} />
        </div>
        <h1 className="font-serif text-2xl text-zinc-100 capitalize">{derived || 'Stranica'}</h1>
        <p className="text-sm text-zinc-400 mt-2 max-w-md mx-auto">
          {description || 'Ova putanja nema dodijeljen modul. Provjerite URL ili se vratite na nadzornu ploču.'}
        </p>
        <Link
          to="/admin"
          data-testid="coming-soon-back"
          className="mt-6 inline-flex items-center gap-2 px-4 py-2 text-sm border border-zinc-700 rounded-md hover:border-red-500 hover:text-red-400 transition-colors"
        >
          <ArrowLeft size={14} /> Natrag na nadzornu ploču
        </Link>
      </div>
    </div>
  );
}
